import { useAgencyUsers } from './useAgencyUsers';

export function useUser(userId: string | null | undefined) {
  const query = useAgencyUsers();
  return {
    ...query,
    data: query.data?.data.find((user) => user.id === userId),
  };
}
